import { render, staticRenderFns } from "./BulkUpdate.vue?vue&type=template&id=49151e2c&scoped=true&"
import script from "./BulkUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdate.vue?vue&type=style&index=0&id=49151e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49151e2c",
  null
  
)

export default component.exports